// extracted by mini-css-extract-plugin
module.exports =  {"factoids-wrapper":"_32bbee5fda--factoids-wrapper--mNhn8"};